import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import {creatableSelectStyles} from "./creatableSelectStyles";

export const baseModalStyles = (theme: Theme) =>
    createStyles({
        cardContent: {
            padding: theme.spacing(2, 3),
        },
        red: {
            color: "red"
        },
        titleBar: {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(4),
        },
        inputSearch: {
            "& .MuiInput-root": {
                border: `1px solid ${theme.palette.grey[300]}`,
                padding: "2px 8px",
            },
        },
        tableEmpltyRow: {
            "& .MuiTableCell-root": {
                paddingTop: theme.spacing(1.5),
                paddingBottom: theme.spacing(1.5),
            },
        },
        iconDelete: {
            color: theme.palette.error.main,
        },
        linkDownload: {
            color: "inherit",
            paddingTop: theme.spacing(0.5),
        },
        modalContent: {},
        container: {
            padding: theme.spacing(2),
        },
        btnCancel: {},
        tableContainer: {
            overflowY: "auto",
            "& .MuiOutlinedInput-input": {
                ...theme.typography.caption,
            },
        },
        root: {
            width: "100%",
        },
        content: {
            display: "flex",
        },
        noData: {
            width: "100%",
            height: "300px",
            border: `1px solid ${theme.palette.grey[200]}`,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        noDataText: {
            color: theme.palette.grey[300],
        },
        sideGradient: {
            top: "0px",
            width: "34px",
            marginLeft: "-24px",
            background:
                "linear-gradient(90deg, rgb(255, 255, 255, 1) 30%, rgb(255, 255, 255, 0))",
            zIndex: 100,
        },
        sideButtons: {
            top: "0px",
            width: "80px",
            boxShadow: "-5px -5px 5px 0 rgba(30, 30, 30, 0.05)",
            color: theme.palette.primary.main,
            backgroundColor: "#FFF0F2",
            textAlign: "center",
            zIndex: 1,
        },
        sideButtonHead: { height: "75px", width: "70px" },
        sideButton: { height: "35px", width: "70px" },
        menu: {
            height: "300px",
            display: "flex",
            flexDirection: "column",
            padding: theme.spacing(1, 2),
            overflowY: "scroll",
        },
        menuTitle: {
            marginBottom: theme.spacing(2),
        },
        menuLabel: { color: theme.palette.primary.main },
        menuLabelSelected: {
            color: theme.palette.primary.main,
            fontWeight: "bold",
        },
        tableWrapperSmart: {
            marginLeft: "-28px",
            paddingLeft: "19px",
            marginRight: "-2px",
            width: "100%",
            overflowX: "scroll",
        },
        tableWrapper: {
            width: "100%",
        },
        columnTitle: {
            fontSize: "12px",
            fontWeight: "bold",
        },
        visuallyHidden: {
            border: 0,
            clip: "rect(0 0 0 0)",
            height: 1,
            margin: -1,
            overflow: "hidden",
            padding: 0,
            position: "absolute",
            top: 20,
            width: 1,
        },
        textField: {
            margin: 0,
        },
        textFieldColored: {
            margin: 0,
            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.primary.main,
            },
            "& .MuiOutlinedInput-root:hover:not(.Mui-disabled):not(.Mui-focused):not(.Mui-error) .MuiOutlinedInput-notchedOutline":
                {
                    borderColor: theme.palette.primary.main,
                },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.primary.main,
            },
        },
        toggleIcon: {
            borderRadius: "100%",
            margin: -5,
            padding: 0,
            marginLeft: 0.5,
            transition: "transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        },
        select: {
            width: "150px",
            [theme.breakpoints.down("md")]: {
                width: "100px",
            },
        },
        fixedWidth: {
            width: theme.spacing(22),
        },
        ...creatableSelectStyles(theme),
    });

export const useModalPreviewStyles = makeStyles((theme: Theme) =>
    createStyles({
        ...baseModalStyles(theme),
        btnContainer: {
            padding: theme.spacing(2, 0),
            marginBottom: theme.spacing(2),
        },
        table: {
            border: `1px solid ${theme.palette.grey[300]}`,
            "& .MuiTableBody-root .MuiTableRow-root:nth-child(odd)": {
                backgroundColor: theme.palette.grey[50],
            },
            "& .MuiTableCell-root": {
                border: `1px solid ${theme.palette.grey[300]}`,
                padding: theme.spacing(1),
                textAlign: "center",
                ...theme.typography.caption,
            },
            "& .MuiTableCell-head": {
                ...theme.typography.caption,
                fontWeight: 500,
                textAlign: "center",
            },
        },
    })
);

export const useModalDeliveryStyles = makeStyles((theme: Theme) =>
    createStyles({
        ...baseModalStyles(theme),
        btnContainer: {
            padding: theme.spacing(2, 0),
        },
        table: {
            border: `1px solid ${theme.palette.grey[300]}`,
            "& .MuiTableBody-root .MuiTableRow-root:nth-child(odd)": {
                backgroundColor: theme.palette.grey[50],
            },
            "& .MuiTableCell-root": {
                border: `1px solid ${theme.palette.grey[300]}`,
                padding: theme.spacing(1),
                ...theme.typography.caption,
            },
            "& .MuiTableCell-head": {
                ...theme.typography.caption,
                fontWeight: 500,
            },
        },
    })
);

export const useModalPOSDownloadStyles = makeStyles((theme: Theme) =>
    createStyles({
        modalContent: {
            minHeight: "220px",
            minWidth: "500px",
            display: "flex",
            flexDirection: "column",
        },
        marginBottom: {
            "margin-bottom": theme.spacing(2),
        },
        btnLeft: {
            marginRight: theme.spacing(3),
        },
        labelName: {
            fontSize: "13px",
            color: theme.palette.grey[400],
        },
        circularProgressContainer: {
            position: "absolute",
            zIndex: 10,
            left: 0,
            right: 0,
            top: "100px",
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: theme.palette.background.paper,
        },
        circularProgress: {
            width: "48px",
            height: "48px",
        },
    })
);

export const useModalSaveStyles = makeStyles((theme: Theme) =>
    createStyles({
        modalContent: {},
        btnContainer: {
            marginTop: theme.spacing(3),
        },
        marginBottom: {
            "margin-bottom": theme.spacing(2),
        },
        btnLeft: {
            marginRight: theme.spacing(3),
        },
        noteText: {
            color: theme.palette.error.main,
            fontWeight: 500,
        },
        commentTitle: {
            fontWeight: 500,
        },
        errorMsg: {
            marginTop: theme.spacing(2),
        },
    })
);

export const useModalSaveTransferStyles = makeStyles((theme: Theme) =>
    createStyles({
        modalContent: {},
        btnContainer: {
            marginTop: theme.spacing(3),
        },
        marginBottom: {
            "margin-bottom": theme.spacing(2),
        },
        btnLeft: {
            marginRight: theme.spacing(3),
        },
        noteText: {
            color: theme.palette.error.main,
            fontWeight: 500,
        },
        commentTitle: {
            fontWeight: 500,
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
        },
        errorMsg: {
            marginTop: theme.spacing(2),
        },
        fixedWidth: {
            width: theme.spacing(22),
        },
        ...creatableSelectStyles(theme),
    })
);

export const useModalAddEditCollabStyles = makeStyles((theme: Theme) =>
    createStyles({
        modalContent: {},
        btnContainer: {
            paddingTop: theme.spacing(2),
            display: "flex",
            flexWrap: "nowrap",
            justifyContent: "space-between",
        },
        marginBottom: {
            "margin-bottom": theme.spacing(2),
        },
        btnCancel: {
            backgroundColor: theme.palette.error.main,
            color: "white",
            marginRight: theme.spacing(2.5),
        },
        labelName: {
            ...theme.typography.caption,
            letterSpacing: "-0.25px",
            color: theme.palette.grey[400],
        },
    })
);

export const useModalAddEditUserStyles = makeStyles((theme: Theme) =>
    createStyles({
        modalContent: {},
        btnContainer: {
            paddingTop: theme.spacing(2),
        },
        select: {
            marginBottom: theme.spacing(2),
        },
        inputContainer: {
            "margin-bottom": theme.spacing(2),
            "& .MuiInput-root": {
                border: `1px solid ${theme.palette.grey[300]}`,
                padding: "2px 10px",
            },
        },
    })
);

export const useModalAddStorageStyles = makeStyles((theme: Theme) =>
    createStyles({
        modalContent: {},
        btnContainer: {
            paddingTop: theme.spacing(2),
            display: "flex",
            flexWrap: "nowrap",
            justifyContent: "space-around",
        },
        greyText: {
            color: theme.palette.action.disabled,
        },
        select: {
            marginBottom: theme.spacing(0),
        },
        marginBottom: {
            "margin-bottom": theme.spacing(2),
        },
        btnCancel: {
            backgroundColor: theme.palette.error.main,
            color: "white",
            marginRight: theme.spacing(0),
        },
        labelName: {
            fontSize: "13px",
            color: theme.palette.grey[400],
        },
        textSpace: {
            paddingi: theme.spacing(2),
        },
    })
);

export const useModalEditStyles = makeStyles((theme: Theme) =>
    createStyles({
        marginTop: {
            paddingTop: theme.spacing(2),
        },
        btnContainer: {
            paddingTop: theme.spacing(6),
        },
        iconDelete: {
            color: theme.palette.error.main,
        },
        marginBottom: {
            "margin-bottom": theme.spacing(2),
        },
    })
);

export const useModalConfirmStyles = makeStyles((theme: Theme) =>
    createStyles({
        modalContent: {},
        userContainer: {
            padding: theme.spacing(2),
        },
        btnContainer: {
            padding: theme.spacing(2, 5),
        },
        btnCancel: {},
        titleContainer: {
            padding: theme.spacing(3),
        },
    })
);

export const useModalSimpleStyles = makeStyles((theme: Theme) =>
    createStyles({
        modalContent: {},
        userContainer: {
            padding: theme.spacing(2),
        },
        btnContainer: {
            padding: theme.spacing(2, 0),
        },
        btnCancel: {},
    })
);
